export default {
  Download: "Tải QRCode",
  GenQRCode: "Xem thông tin chi tiết",
  PaySuccess: "Đơn hàng đã được thanh toán thành công",
  OrderList: "Danh sách hóa đơn",
  PayConfirm: "Xác nhận thanh toán",
  CompanyName: "Công ty cổ phần JetPay",
  NewLink: "Tạo link mới",
  Back: "Quay lại",
  TimeoutExpiredTime: "Đã hết hạn thanh toán",
  LocalCard: "Thẻ nội địa",
  PaymentLinkList: {
    Title: "Danh sách payment links",
    Search: "Tìm kiếm",
    CreatePaymentlink: "Tạo payment link",
    List: {
      Time: "Thời gian",
      URL: "Đường dẫn",
      Amount: "Số tiền",
      Description: "Nội dung",
      CustomerCode: "Mã khách hàng",
      Status: "Trạng thái",
      Type: "Loại link",
    },
    Placeholder: {
      Type: "Loại: Tất cả",
      Status: "Trạng thái: Chờ thanh toán",
    },
    Create: {
      Title: "Tạo payment link",
      Type: "Loại",
      PurchaseLink: "Link mua hàng",
      BillPaymentLink: "Link thanh toán hóa đơn",
      Amount: "Số tiền",
      PaymentTerm: "Thời hạn thanh toán",
      Description: "Nội dung",
      CustomerCode: "Mã khách hàng",
      NoTime: "Không có thời lượng",
      Create: "Tạo link",
    },
  },
  Messenger: {
    CreateSuccess: "Tạo link payment thành công!",
    AmountLimit: "Bạn đang yêu cầu thanh toán với số tiền lớn. Bạn có chắc muốn tiếp tục?",
    Announce: "Thông báo",
    Warning: "Cảnh báo",
    NotEmpty: "Vui lòng nhập thời gian vào ô tìm kiếm",
    FormatDateWrong: "Nhập sai định dạng thời gian. Vui lòng kiểm tra lại",
    DisDateLong: "Khoảng cách Từ ngày - Đến ngày không quá 31 ngày",
    FromDateLong: "Không thể tìm kiếm cách ngày hiện tại quá 180 ngày",
    FromDateLongSixMonth: "Ngày bắt đầu không được quá 6 tháng so với ngày hiện tại",
    FromDateLongTwelveMonth: "Ngày bắt đầu không được quá 12 tháng so với ngày hiện tại",
    DisDateFail: "Từ ngày không được vượt quá Đến ngày",
    DisMonthFail: "Từ tháng không được vượt quá Đến tháng",
    ToDateFail: "Không được tìm kiếm vượt quá ngày hiện tại",
    DisDateWrong: "Chỉ được tìm kiếm kết quả từ một tháng trở về trước",
    DisDateLongSixMonth: "Không thể tìm kiếm cách ngày hiện tại quá 180 ngày",
    DisDateLongV2: "Khoảng cách Từ ngày – Đến ngày không quá 31 ngày",
    Identify: "Tài khoản của bạn đang được phê duyệt. Vui lòng quay lại sau",
    NoDelete: "Chỉ được xóa link đang chờ thanh toán",
    DeleteLink: "Bạn có chắc chắn muốn xóa link thanh toán đã chọn không? ",
    Confirm: "Bạn vui lòng định danh tài khoản để sử dụng dịch vụ",
    AmountLange: "Số tiền thanh toán quá lớn, không thể thực hiện thanh toán.",
    NotActive: "Tính năng không được kích hoạt với tài khoản này",
  },
  Order: {
    Amount: "Số tiền",
    CustormerName: "Tên khách hàng",
    FeeAmount: "Phí thanh toán",
    TotalAmount: "Tổng tiền thanh toán",
  },
  Error: {
    Time: "Thời hạn thanh toán tối thiếu 30 phút và tối đa 24 giờ",
    Text: "Text",
    PaymentType: "Vui lòng chọn phương thức để thanh toán",
  },
  QRCodePopup: {
    Header: "Thông tin link nhận thanh toán",
    Amount: "Số tiền",
    Status: "Trạng thái",
    CreatedTime: "Thời gian tạo",
    Description: "Nội dung",
  },
  Footer: {
    NameCompany: "Công ty cổ phần JETPAY",
    AddressCompany:
      "Tầng 9, Tòa nhà Technosoft, ngõ 15 Duy Tân, Phường Dịch Vọng Hậu, Quận Cầu Giấy, Thành phố Hà Nội, Việt Nam",
    LicenseCompany:
      "Giấy phép hoạt động cung ứng dịch vụ Trung gian thanh toán số 06/GP-NHNN ngày 22/01/2021",
    HelpTitle: "Hỗ trợ khách hàng",
    HotlineTitle: "Tổng đài từ vấn (3.000đ/phút)",
    HotlineNumber: "19002169",
    Email: "support@jetpay.com",
  },
};
